import { cloneDeep, isObject } from 'lodash';

// This class is used to enable Selection for a Card Column display component.
export class CardColumnSelectionBase {
  constructor(
    selectionType: 'single' | 'multiple' = 'multiple',
    inputData: any,
    options?: {
      // Can choose to prevent data cloning.
      preventDataClone?: boolean;
      selectionLimit?: number | null;
      ignoreDuplicatesForSelectionLimit?: boolean;
    }
  ) {
    const {
      preventDataClone = false,
      selectionLimit = null,
      ignoreDuplicatesForSelectionLimit = false
    } = options || {};

    this.selectionType = selectionType;
    this.selectionLimit = selectionLimit;
    this.ignoreDuplicatesForSelectionLimit = ignoreDuplicatesForSelectionLimit;
    // Input data needs to be either an object or an array.
    if (!isObject(inputData)) {
      throw new Error('inputData must be either an object or an array.');
    }
    this.inputData = inputData;
    this.originalInputData = cloneDeep(this.inputData);
    this.data = preventDataClone ? this.inputData : cloneDeep(this.inputData);
  }

  selectionType: 'single' | 'multiple';

  // This can, optionally, be used to limit the number of selections a user can make.
  selectionLimit: number | null;

  // This is an optional parameter that ignores duplicate values with respect to the selection
  // limit. This includes variable references to the same object.
  ignoreDuplicatesForSelectionLimit: boolean;

  // If we choose to not clone the data, we need to track the original input data. This way, if this is used
  // in a modal, and a cancel action is selected, we can revert the input data to the originally input data.
  originalInputData?: any;

  // This is the data array/object to be passed to this component. The values from this array/object
  // are cloned and stored in the underlying data array/object. These values are NOT mutated.
  // The data array/object is returned when the 'continue' button is selected.
  //inputArray: any;
  inputData: any;

  // This represents the underlying data structure of this component (array/object). This values from the input
  // array/object are copied into this array/object to prevent mutation of the original array/object.
  public data: any;
}
